export const PROJECT_MODES = {
	INTERACTIVE_MAPS_MODE: "Interactive Maps",
	PLACEBO_MODE: "Placebo"
}

export const STRING_VALUES = {
	PLACEBO_HEADER: "Annotated 1402 Korean World Map",
	MAP_CREDITS: "Map Credit: Jim Siebold, https://www.myoldmaps.com, Accessed Date: 11/01/22"
}

export const ACTIVITY_TYPES = {
	CLICK: "CLICK",
	UNSELECT: "UNSELECT",
	HOVER: "HOVER",
	LOGIN: "LOGIN",
	LOGOUT: "LOGOUT",
	AUTOMATIC_LOGOUT: "AUTOMATIC LOGOUT",
	TAB_CLOSE: "TAB CLOSED",
	TAB_CHANGE: "TAB CHANGED",
	ERROR: "ERROR",
	SAVE_NOTES: "SAVE NOTES",
	OPEN_NOTES: "OPEN NOTES",
	CLOSE_NOTES: "CLOSE NOTES",
	SAVE_CANVAS: 'SAVE_CANVAS',
	SAVE_LEFT_IMAGE: 'SAVE_LEFT_IMAGE',
	SAVE_RIGHT_IMAGE: 'SAVE_RIGHT_IMAGE'
}

export const DEFAULT_SYSTEM_CONFIGURATIONS = {
	HOVER_THRESHOLD: 2
}